import RequestList from './RequestList'
import RequestCreate from './RequestCreate'
import RequestSingle from './RequestSingle'
import RequestEdit from './RequestEdit'
import RequestDuplicate from './RequestDuplicate'
import RequestAdminOptions from './RequestAdminOptions'

export default {
  RequestList,
  RequestCreate,
  RequestSingle,
  RequestEdit,
  RequestDuplicate,
  RequestAdminOptions
}
